module.exports = __webpack_public_path__ + "img/movies-folder.46740d98.png";